"use strict";

var moduleName = "aside";

module.exports = function () {
	$(".jsAside").each(function () {
		if($.data(this, moduleName + "-init")) return;
		$.data(this, moduleName + "-init", true);


		//
		// Сворачиваем все блоки по умолчанию
		//

		$(window).on("load", function() {
			var width = window.innerWidth;

			if (width <= 970) {
				$(".jsCatalogMenuBtnDropDown, .jsFilterBtnDropDown, .jsRecentGoodsBtnDropDown").removeClass("active");
				$(".jsCatalogMenuRow, .jsFilterRow, .jsRecentGoodsRow").hide(200);
			}
		});


		//
		// Сворачивание меню каталога
		//

		$(".jsCatalogMenuBtnDropDown").on("click", function(e) {
			e.preventDefault();

			$(this).toggleClass("active");
			$(".jsCatalogMenuRow").toggle(200);
		});






		//
		// Блок "Вы смотрели"
		//

		$(".jsRecentGoodsBtnDropDown").on("click", function(e) {
			e.preventDefault();

			$(this).toggleClass("active");
			$(".jsRecentGoodsRow").toggle(200);
		});

		$(window).resize(function() {
			var width = window.innerWidth;

			if (width > 970) {
				$(".jsRecentGoodsRow").show(200);
			}

			if ($(".jsRecentGoodsRow").is(":visible")) {
				$(".jsRecentGoodsBtnDropDown").addClass("active");
			}
		});

		var visibleRecentGoodsList = $(".jsRecentGoodsListItem:visible").length;

		$(".jsRecentGoodsBtnShowAll").on("click", function(e) {
			e.preventDefault();

			if($(this).hasClass("active")) {
				$(this).removeClass("active").html("<span>Показать все</span>");
				$(".jsRecentGoodsListItem:not(:lt("+visibleRecentGoodsList+"))").hide();
			} else {
				$(this).html("<span>Свернуть</span>").addClass("active");
				$(".jsRecentGoodsListItem").show();
			}
		});






		//
		// Фильтр
		//

		$(".jsFilterBtnDropDown").on("click", function(e) {
			e.preventDefault();

			$(this).toggleClass("active");
			$(".jsFilterRow").toggle(200);
		});

		$(window).resize(function() {
			var width = window.innerWidth;

			if (width > 970) {
				$(".jsFilterRow").show(200);
			}

			if ($(".jsFilterRow").is(":visible")) {
				$(".jsFilterBtnDropDown").addClass("active");
			}
		});

		$(".jsFilterItemLineTitleDropDown").on("click", function(e) {
			e.preventDefault();

			$(this).toggleClass("active");
			$(this).nextAll(".jsFilterItemLineCheckboxWrapper").toggle(200);
		});






		//
		// Фильтр (Заданы параметры фильтра)
		//

		// $(window).on("load resize", function() {
		// 	var width = window.innerWidth;
		//
		// 	console.log("1");
		//
		// 	if (width < 970) {
		// 		console.log("2");
		//
		// 		if($(".jsFilterBtnDropDown").hasClass("active")) {
		// 			console.log("3");
		//
		// 			if($(".jsFilterBtnDropDown").hasClass("active")) {
		// 				console.log("4");
		//
		//
		// 			}
		// 		}
		// 	}
		// });

		

	});
};









/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/asideInit.js
 **/